// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.financialInfo__netWorth {
  display: flex;
  -webkit-display: flex;
  padding: 8px 14px;
  border: 1px solid #edf0f2;
  max-width: 334px;
  justify-content: space-between;
  border-radius: 6px;
  margin: 0 auto 20px;
  background: #fff;
}
.financialInfo__netWorthField {
  margin-right: 10px;
}
.financialInfo__netWorthField:last-child {
  margin-right: 0;
}
.financialInfo__netWorthLabel {
  color: #e0a633;
  font-size: 13px;
  font-style: italic;
  font-weight: 700;
  line-height: 1.5;
}
.financialInfo__netWorthCalc {
  color: #505050;
  font-size: 10px;
  font-style: italic;
  line-height: 1.5;
}
.financialInfo__netWorthYear {
  font-size: 12px;
  color: #505050;
  font-weight: 600;
  line-height: 1.5;
}
.financialInfo__netWorthValue {
  color: #222222;
  line-height: 1.5;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5;
}
.financialInfo__accordionHeadingWrapper {
  padding: 20px 20px 15px;
  border: 1px solid #edf0f2;
  border-radius: 6px;
  display: flex;
  -webkit-display: flex;
  justify-content: space-between;
  background: #fff;
  position: relative;
}
.financialInfo__accordionHeadingWrapper.accordion-active {
  background: #e5f1f8;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.financialInfo__accordionHeadingWrapper.accordion-active
  .financialInfo__accordionHeading {
  color: #0177b5;
}
.financialInfo__accordionHeadingWrapper .accordionClickCapture {
  cursor: pointer;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  border-radius: 6px;
  top: 0;
  left: 0;
}
.financialInfo__accordionHeading {
  font-size: 16px;
  color: #505050;
  font-weight: 700;
  line-height: 1.5;
  margin-bottom: 5px;
}
.financialInfo__tableRow {
  display: flex;
  -webkit-display: flex;
}
.financialInfo__rowLabel {
  font-size: 14px;
  color: #000000;
  line-height: 1.5;
  display: inline-block;
}
.financialInfo__tableTotal {
  display: flex;
  -webkit-display: flex;
}
.financialInfo__rowTotal {
  font-size: 12px;
  color: #505050;
  font-weight: 700;
  display: inline-block;
  line-height: 1.5;
}
.financialInfo__tableLabelHeader > span,
.financialInfo__currYearHeaderLabel > span,
.financialInfo__prevYearHeaderLabel > span,
.financialInfo__currYearHeaderField > span,
.financialInfo__prevYearHeaderField > span,
.financialInfo__remarkHeader > span {
  font-size: 12px;
  color: #505050;
  line-height: 1.5;
  display: inline-block;
  font-weight: 700;
}
.financialInfo__tableFixedColWrapper.financialInfo__tableWrapper {
  position: relative;
}
.financialInfo__tableFixedColWrapper .financialInfo__table {
  width: calc(100% - 220px);
  overflow-x: scroll;
  overflow-y: hidden;
  margin-left: 220px;
}
.financialInfo__tableFixedColWrapper .financialInfo__tableCol {
  position: absolute;
  width: 220px;
  left: 0;
  top: auto;
  height: 50px;
}
.financialInfo__tableFixedColWrapper th.financialInfo__tableCol {
  height: 97px;
}
th.financialInfo__tableCol .financialInfo__tableColHeading {
  display: flex;
  -webkit-display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.financialInfo__tableCol {
  width: 320px;
  vertical-align: middle;
}
.financialInfo__table tfoot td {
  border-bottom: 2px solid #f1f4f6;
  border-top: 2px solid #f1f4f6;
}
.financialInfo__tableFixedColWrapper tfoot td.financialInfo__tableCol {
  height: 65px;
}
.financialInfo__tableWrapper
  .label-value-wrapper.financialInfo__tableColHeadTop {
  justify-content: center;
  align-items: center;
  display: flex;
  -webkit-display: flex;
  height: 40px;
  width: 100%;
  background: #f1f4f6;
  margin: 0;
  text-align: center;
}
.financialInfo__tableColLabel {
  font-size: 14px;
  color: #000000;
  line-height: 1.5;
  display: flex;
  -webkit-display: flex;
  height: 100%;
  align-items: center;
  padding-right: 10px;
  padding-left: 10px;
}
tfoot .financialInfo__tableColLabel {
  font-weight: 600;
}
.financialInfo__table th {
  font-size: 12px;
  color: #000000;
  line-height: 1.5;
  border-bottom: 2px solid #f1f4f6;
  vertical-align: middle;
}
.financialInfo__tableFixedColWrapper
  .financialInfo__table
  .financialInfo__tableCol {
  border-right: 2px solid #f1f4f6;
}
.financialInfo__tableFixedColWrapper
  .financialInfo__table
  tbody
  td.financialInfo__tableCol {
  height: 65px;
}
.financialInfo__table th span {
  text-align: left;
}
.financialInfo__tableWrapper .label-value-wrapper {
  display: inline-block;
  width: 90px;
  vertical-align: top;
  margin: 10px 0 10px 6px;
}
.financialInfo__tableWrapper .label-value-wrapper input[type="text"] {
  padding: 0 2px;
  font-size: 13px;
}
.financialInfo__plansInfoTotal {
  margin-right: 5px;
}
.financialInfo__plansInfoTotalLabel {
  font-size: 12px;
  line-height: 1.5;
  color: #505050;
  font-weight: 600;
}
.financialInfo__plansInfoTotalValue {
  color: #505050;
  font-size: 14px;
  line-height: 1.4;
  font-weight: 700;
}
.label-value-wrapper.financialInfo_remarkWrapper {
  width: 225px;
  margin-right: 20px;
}
.financiaInfo_questionsection .field-label {
  color: #222222;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
}
/*Scrollbar Css Starts Here*/
/* Firefox */
.financialInfo__tableFixedColWrapper .financialInfo__table::-webkit-scrollbar {
  scrollbar-width: auto;
  scrollbar-color: #918d8d #ffffff;
}

/* Chrome, Edge, and Safari */
.financialInfo__tableFixedColWrapper .financialInfo__table::-webkit-scrollbar {
  width: 10px;
}

.financialInfo__tableFixedColWrapper
  .financialInfo__table::-webkit-scrollbar-track {
  background: #ffffff;
}

.financialInfo__tableFixedColWrapper
  .financialInfo__table::-webkit-scrollbar-thumb {
  background-color: #918d8d;
  border-radius: 10px;
  border: 3px solid #ffffff;
}
.financialInfo_realEstateContents {
  padding: 20px;
}
.financiaInfo_section {
  background: #fff;
  margin-bottom: 12px;
  border-radius: 6px;
}
.financiaInfo_section.financiaInfo_questionsection {
  background: transparent;
}
.financialInfo__tableFixedColWrapper .financialInfo__remarkHeader {
  background: #f1f4f6;
}
.financialInfo__accordionHeadingWrapper.amountHeader {
  justify-content: flex-start;
}
.amountHeader .financialInfo__accordionHeading {
  width: 34%;
}
.financialInfo__plansInfo {
  display: flex;
  -webkit-display: flex;
  width: 34%;
}
.financialInfo__initialFinanplansInfo {
  width: 36%;
}
.financialInfo__initialFinanplansInfo .financialInfo__netWorthField {
  margin-right: 0;
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.financialInfo__initialFinanplansInfo .financialInfo__netWorthCalc {
  margin-left: 5px;
  font-size: 12px;
}
.financialInfo__initialFinanInfo .financialInfo__plansInfo {
  width: 100%;
}

.financialInfo__plansInfo .financialInfo__plansInfoTotal {
  width: 50%;
}
.amountHeader .acc_icon {
  width: 32%;
  text-align: right;
  padding-top: 10px;
}
.financialInfo__tableFixedColWrapper
  .financialInfo__table
  tbody
  .textbox__describeOther
  td {
  height: 80px;
}
.textbox__describeOther .financialInfo__tableCol .label-value-wrapper {
  width: 100%;
  margin-left: 0;
  margin-top: 5px;
}
.textbox__describeOther .financialInfo__tableCol .label-value-wrapper input {
  height: 40px;
  line-height: 40px;
}
.textbox__describeOther .financialInfo__tableColLabel {
  display: block;
}
.financialInfo__accordionContent {
  height: 0;
  overflow: hidden;
  transition: height 0.4s ease;
}
.financialInfo__accordionContent--open {
  height: auto;
}
.financiaInfo_questionsection .label-radioButtons-wrapper .radio-label {
  border: 1px solid #505050;
}
.financiaInfo_questionsection
  .label-radioButtons-wrapper
  .radio:checked
  ~ .radio-label {
  border: 1px solid transparent;
}
.financialInfo__accordionHeadingWrapper.financialInfo__initialFinanInfo {
  border-radius: 0;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #edf0f2;
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.spouse__incomeSource {
  display: flex;
  display: -webkit-flex;
  width: 100%;
}
.spouse__incomeSource .tableAmount__label {
  width: 35%;
}
.spouse__incomeSource .tableAmount__remark {
  width: 65%;
}
.spouse__incomeSource .tableAmount__remark .label-value-wrapper {
  display: inline-block;
  width: calc(100% - 20px);
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/financialInformation/FinancialInformation.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;;;;;;EAME,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,SAAS;EACT,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;;EAEE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;AACA;;;EAGE,+BAA+B;AACjC;AACA;;;;EAIE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA,4BAA4B;AAC5B,YAAY;AACZ;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;EACE,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,iBAAiB;AACnB;AACA;;;;;EAKE,YAAY;AACd;AACA;EACE,WAAW;EACX,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;;;;EAIE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B","sourcesContent":[".financialInfo__netWorth {\n  display: flex;\n  -webkit-display: flex;\n  padding: 8px 14px;\n  border: 1px solid #edf0f2;\n  max-width: 334px;\n  justify-content: space-between;\n  border-radius: 6px;\n  margin: 0 auto 20px;\n  background: #fff;\n}\n.financialInfo__netWorthField {\n  margin-right: 10px;\n}\n.financialInfo__netWorthField:last-child {\n  margin-right: 0;\n}\n.financialInfo__netWorthLabel {\n  color: #e0a633;\n  font-size: 13px;\n  font-style: italic;\n  font-weight: 700;\n  line-height: 1.5;\n}\n.financialInfo__netWorthCalc {\n  color: #505050;\n  font-size: 10px;\n  font-style: italic;\n  line-height: 1.5;\n}\n.financialInfo__netWorthYear {\n  font-size: 12px;\n  color: #505050;\n  font-weight: 600;\n  line-height: 1.5;\n}\n.financialInfo__netWorthValue {\n  color: #222222;\n  line-height: 1.5;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.5;\n}\n.financialInfo__accordionHeadingWrapper {\n  padding: 20px 20px 15px;\n  border: 1px solid #edf0f2;\n  border-radius: 6px;\n  display: flex;\n  -webkit-display: flex;\n  justify-content: space-between;\n  background: #fff;\n  position: relative;\n}\n.financialInfo__accordionHeadingWrapper.accordion-active {\n  background: #e5f1f8;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.financialInfo__accordionHeadingWrapper.accordion-active\n  .financialInfo__accordionHeading {\n  color: #0177b5;\n}\n.financialInfo__accordionHeadingWrapper .accordionClickCapture {\n  cursor: pointer;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n  border-radius: 6px;\n  top: 0;\n  left: 0;\n}\n.financialInfo__accordionHeading {\n  font-size: 16px;\n  color: #505050;\n  font-weight: 700;\n  line-height: 1.5;\n  margin-bottom: 5px;\n}\n.financialInfo__tableRow {\n  display: flex;\n  -webkit-display: flex;\n}\n.financialInfo__rowLabel {\n  font-size: 14px;\n  color: #000000;\n  line-height: 1.5;\n  display: inline-block;\n}\n.financialInfo__tableTotal {\n  display: flex;\n  -webkit-display: flex;\n}\n.financialInfo__rowTotal {\n  font-size: 12px;\n  color: #505050;\n  font-weight: 700;\n  display: inline-block;\n  line-height: 1.5;\n}\n.financialInfo__tableLabelHeader > span,\n.financialInfo__currYearHeaderLabel > span,\n.financialInfo__prevYearHeaderLabel > span,\n.financialInfo__currYearHeaderField > span,\n.financialInfo__prevYearHeaderField > span,\n.financialInfo__remarkHeader > span {\n  font-size: 12px;\n  color: #505050;\n  line-height: 1.5;\n  display: inline-block;\n  font-weight: 700;\n}\n.financialInfo__tableFixedColWrapper.financialInfo__tableWrapper {\n  position: relative;\n}\n.financialInfo__tableFixedColWrapper .financialInfo__table {\n  width: calc(100% - 220px);\n  overflow-x: scroll;\n  overflow-y: hidden;\n  margin-left: 220px;\n}\n.financialInfo__tableFixedColWrapper .financialInfo__tableCol {\n  position: absolute;\n  width: 220px;\n  left: 0;\n  top: auto;\n  height: 50px;\n}\n.financialInfo__tableFixedColWrapper th.financialInfo__tableCol {\n  height: 97px;\n}\nth.financialInfo__tableCol .financialInfo__tableColHeading {\n  display: flex;\n  -webkit-display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n.financialInfo__tableCol {\n  width: 320px;\n  vertical-align: middle;\n}\n.financialInfo__table tfoot td {\n  border-bottom: 2px solid #f1f4f6;\n  border-top: 2px solid #f1f4f6;\n}\n.financialInfo__tableFixedColWrapper tfoot td.financialInfo__tableCol {\n  height: 65px;\n}\n.financialInfo__tableWrapper\n  .label-value-wrapper.financialInfo__tableColHeadTop {\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  -webkit-display: flex;\n  height: 40px;\n  width: 100%;\n  background: #f1f4f6;\n  margin: 0;\n  text-align: center;\n}\n.financialInfo__tableColLabel {\n  font-size: 14px;\n  color: #000000;\n  line-height: 1.5;\n  display: flex;\n  -webkit-display: flex;\n  height: 100%;\n  align-items: center;\n  padding-right: 10px;\n  padding-left: 10px;\n}\ntfoot .financialInfo__tableColLabel {\n  font-weight: 600;\n}\n.financialInfo__table th {\n  font-size: 12px;\n  color: #000000;\n  line-height: 1.5;\n  border-bottom: 2px solid #f1f4f6;\n  vertical-align: middle;\n}\n.financialInfo__tableFixedColWrapper\n  .financialInfo__table\n  .financialInfo__tableCol {\n  border-right: 2px solid #f1f4f6;\n}\n.financialInfo__tableFixedColWrapper\n  .financialInfo__table\n  tbody\n  td.financialInfo__tableCol {\n  height: 65px;\n}\n.financialInfo__table th span {\n  text-align: left;\n}\n.financialInfo__tableWrapper .label-value-wrapper {\n  display: inline-block;\n  width: 90px;\n  vertical-align: top;\n  margin: 10px 0 10px 6px;\n}\n.financialInfo__tableWrapper .label-value-wrapper input[type=\"text\"] {\n  padding: 0 2px;\n  font-size: 13px;\n}\n.financialInfo__plansInfoTotal {\n  margin-right: 5px;\n}\n.financialInfo__plansInfoTotalLabel {\n  font-size: 12px;\n  line-height: 1.5;\n  color: #505050;\n  font-weight: 600;\n}\n.financialInfo__plansInfoTotalValue {\n  color: #505050;\n  font-size: 14px;\n  line-height: 1.4;\n  font-weight: 700;\n}\n.label-value-wrapper.financialInfo_remarkWrapper {\n  width: 225px;\n  margin-right: 20px;\n}\n.financiaInfo_questionsection .field-label {\n  color: #222222;\n  font-size: 14px;\n  line-height: 1.5;\n  font-weight: 400;\n}\n/*Scrollbar Css Starts Here*/\n/* Firefox */\n.financialInfo__tableFixedColWrapper .financialInfo__table::-webkit-scrollbar {\n  scrollbar-width: auto;\n  scrollbar-color: #918d8d #ffffff;\n}\n\n/* Chrome, Edge, and Safari */\n.financialInfo__tableFixedColWrapper .financialInfo__table::-webkit-scrollbar {\n  width: 10px;\n}\n\n.financialInfo__tableFixedColWrapper\n  .financialInfo__table::-webkit-scrollbar-track {\n  background: #ffffff;\n}\n\n.financialInfo__tableFixedColWrapper\n  .financialInfo__table::-webkit-scrollbar-thumb {\n  background-color: #918d8d;\n  border-radius: 10px;\n  border: 3px solid #ffffff;\n}\n.financialInfo_realEstateContents {\n  padding: 20px;\n}\n.financiaInfo_section {\n  background: #fff;\n  margin-bottom: 12px;\n  border-radius: 6px;\n}\n.financiaInfo_section.financiaInfo_questionsection {\n  background: transparent;\n}\n.financialInfo__tableFixedColWrapper .financialInfo__remarkHeader {\n  background: #f1f4f6;\n}\n.financialInfo__accordionHeadingWrapper.amountHeader {\n  justify-content: flex-start;\n}\n.amountHeader .financialInfo__accordionHeading {\n  width: 34%;\n}\n.financialInfo__plansInfo {\n  display: flex;\n  -webkit-display: flex;\n  width: 34%;\n}\n.financialInfo__initialFinanplansInfo {\n  width: 36%;\n}\n.financialInfo__initialFinanplansInfo .financialInfo__netWorthField {\n  margin-right: 0;\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n}\n.financialInfo__initialFinanplansInfo .financialInfo__netWorthCalc {\n  margin-left: 5px;\n  font-size: 12px;\n}\n.financialInfo__initialFinanInfo .financialInfo__plansInfo {\n  width: 100%;\n}\n\n.financialInfo__plansInfo .financialInfo__plansInfoTotal {\n  width: 50%;\n}\n.amountHeader .acc_icon {\n  width: 32%;\n  text-align: right;\n  padding-top: 10px;\n}\n.financialInfo__tableFixedColWrapper\n  .financialInfo__table\n  tbody\n  .textbox__describeOther\n  td {\n  height: 80px;\n}\n.textbox__describeOther .financialInfo__tableCol .label-value-wrapper {\n  width: 100%;\n  margin-left: 0;\n  margin-top: 5px;\n}\n.textbox__describeOther .financialInfo__tableCol .label-value-wrapper input {\n  height: 40px;\n  line-height: 40px;\n}\n.textbox__describeOther .financialInfo__tableColLabel {\n  display: block;\n}\n.financialInfo__accordionContent {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.4s ease;\n}\n.financialInfo__accordionContent--open {\n  height: auto;\n}\n.financiaInfo_questionsection .label-radioButtons-wrapper .radio-label {\n  border: 1px solid #505050;\n}\n.financiaInfo_questionsection\n  .label-radioButtons-wrapper\n  .radio:checked\n  ~ .radio-label {\n  border: 1px solid transparent;\n}\n.financialInfo__accordionHeadingWrapper.financialInfo__initialFinanInfo {\n  border-radius: 0;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  border-bottom: 1px solid #edf0f2;\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n}\n.spouse__incomeSource {\n  display: flex;\n  display: -webkit-flex;\n  width: 100%;\n}\n.spouse__incomeSource .tableAmount__label {\n  width: 35%;\n}\n.spouse__incomeSource .tableAmount__remark {\n  width: 65%;\n}\n.spouse__incomeSource .tableAmount__remark .label-value-wrapper {\n  display: inline-block;\n  width: calc(100% - 20px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
